import { Company } from '../company/types';
import { FieldValue } from '../field/types';
import { Role } from '../role/types';

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
}
export enum UserType {
  Native = 'NATIVE',
  External = 'EXTERNAL',
  Partner = 'PARTNER',
  CustomerPartner = 'EXTERNAL_PARTNER',
  CustomerPortalBot = 'CUSTOMER_PORTAL_BOT',
}

export interface User {
  createdAt?: number;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  emailId: string;
  userId: number;
  photoUrl?: string;
  userType: UserType;
  company: Company;
  role?: Role;
  userStatus: UserStatus;
  timeZone?: string;
  fields?: Array<FieldValue>;
  defaultCapacity: boolean;
  capacityMinutes: number; // weekly capacity
  projectIds?: Array<number>;
  timeSheetApprover?: number;
  meetingRecordingEnabled?: boolean;
  calendarStatus?: boolean;
  emailIntelligenceEnabled?: boolean;
  holidayCalendarId?: number;
  reportingTo?: number;
  managerOf?: number[];
  permissionSet?: {
    permissionSetId: number;
    permissionSetName: string;
    permissionSetType: number;
  };
  emailLanguagePreference?: string;
}
export type UserId = number;
export type UserProfileInfo = {
  company: Company;
  user: User;
  userMeta: UserMeta;
};

export type UserMeta = {
  accountId: number;
  userId: number;
};
